import { API_BASE_URL } from '../config';

const BASE_URL = `${API_BASE_URL}placegroups`;

const handleResponse = async (res) => {
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.message || 'Something went wrong');
  }
  return res.json();
};

// Factory function that returns service methods with token
export const createPlaceGroupService = (token) => {
  const getAuthHeaders = () => ({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  });

  return {
    getGroups: async () => {
      const res = await fetch(BASE_URL, {
        headers: getAuthHeaders(),
      });
      return handleResponse(res);
    },

    getPlaces: async (groupId) => {
      const res = await fetch(`${BASE_URL}/${groupId}/places`, {
        headers: getAuthHeaders(),
      });
      return handleResponse(res);
    },
    getWithoutGroupPlaces: async () => {
      const groupId =  '%7Bid%7D'; // %7Bid%7D is URL-encoded {id}

      const res = await fetch(`${BASE_URL}/${groupId}/places`, {
        headers: getAuthHeaders(),
      });
      return handleResponse(res);
    },

    updateGroup: async (group) => {
      const res = await fetch(`${BASE_URL}/${group.id}`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(group),
      });
      return handleResponse(res);
    },

    createGroup: async (group) => {
      const res = await fetch(BASE_URL, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(group),
      });
      return handleResponse(res);
    },

    deleteGroup: async (group) => {
      const res = await fetch(`${BASE_URL}/${group.id}`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
      });
      return handleResponse(res);
    },

    updateGroupLinks: async (groupId, data) => {
      const res = await fetch(`${BASE_URL}/${groupId}/links`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(data),
      });
      return handleResponse(res);
    },
  };
};


